import { CodebookModel } from 'app/shared/model/shared.model';
import { LegalEntityModel, PersonModel } from 'app/shared/oib/oib.model';
import { AddressModel, initialAddress } from 'app/shared/address-input/model/address.model';

export interface AddedPersonModel {
  idAddedPerson?: number;
  subjectType?: CodebookModel[];
  person: PersonModel;
  legalEntity: LegalEntityModel;
  email?: string;
  telephoneNumber?: string;
  address: AddressModel;
}

export interface AddedPersonView {
  idAddedPerson: number;
  name: string;
  oibMb: string;
  address: string;
  email: string;
}

export const addedPersonInitialData = {
  email: '',
  telephoneNumber: '+385',
  subjectType: [],
  person: {
    oib: '',
    firstName: '',
    lastName: '',
    dateOfBirth: null,
    address: null,
    subjectType: null,
  },
  legalEntity: {
    oib: '',
    mb: '',
    address: null,
    companyName: '',
    subjectType: null,
  },
  address: initialAddress,
};
